import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Paywall from 'features/paywall/Wrapper/Widget';
import { SideWidgetAnalytics as WIDGET } from 'features/paywall/analytics';
import dynamic from 'next/dynamic';
import { Box, StyledTabs } from './styled';
import Header from './Header';

import slice, { effects, selectors } from './slice';
import { BANDAR_DETECTOR_MENU_KEY } from './constants';
import mainLayoutSlice from '../../slice';
import { SIDE_MENU_KEY } from '../constants';

interface BandarDetectorProps {
  isPro: boolean;
  activeKey?: string;
}

const BrokerSummary = dynamic(() => import('./BrokerSummary'));
const TopBroker = dynamic(() => import('./TopBroker'));
const BrokerActivity = dynamic(() => import('./BrokerActivity'));

function BandarDetector({
  isPro,
  activeKey = BANDAR_DETECTOR_MENU_KEY.BROKER_SUMMARY,
}: BandarDetectorProps) {
  const dispatch = useDispatch();
  const { summary } = useSelector(selectors);
  const isBrokerSummary = activeKey === BANDAR_DETECTOR_MENU_KEY.BROKER_SUMMARY;

  const handleTabChange = (val) => {
    dispatch(
      // @ts-ignore
      mainLayoutSlice.actions.setActiveWidget({
        key: SIDE_MENU_KEY.BANDAR_DETECTOR,
        bandarDetectorActiveKey: val,
        isFromBandarDetector: true,
      }),
    );
  };

  useEffect(() => {
    dispatch(
      effects.getBrokerList({
        page: 1,
        limit: 150,
        group: 'GROUP_UNSPECIFIED',
      }),
    );

    return () => {
      dispatch(slice.actions.resetPagination());
    };
  }, []);

  const tabItems = [
    {
      label: 'Broker Summary',
      key: BANDAR_DETECTOR_MENU_KEY.BROKER_SUMMARY,
      children: <BrokerSummary />,
    },
    {
      label: 'Top Broker',
      key: BANDAR_DETECTOR_MENU_KEY.TOP_BROKER,
      children: <TopBroker />,
    },
    {
      label: 'Broker Activity',
      key: BANDAR_DETECTOR_MENU_KEY.BROKER_ACTIVITY,
      children: <BrokerActivity />,
    },
  ];

  return (
    <Box>
      <div
        style={{
          overflow: isBrokerSummary ? 'auto' : 'hidden',
          height: '100vh',
          paddingBottom: '5px',
        }}
        className="bandar-detector-wrapper"
      >
        {isPro ? (
          <StyledTabs activeKey={activeKey} onChange={handleTabChange}>
            {tabItems.map((item) => (
              <StyledTabs.TabPane tab={item.label} key={item.key}>
                {item.children}
              </StyledTabs.TabPane>
            ))}
          </StyledTabs>
        ) : (
          <>
            <Header>
              Bandar Detector {summary?.symbol && `( ${summary.symbol} )`}
            </Header>
            <Paywall height="90vh" source={WIDGET.BANDAR_DETECTOR} />
          </>
        )}
      </div>
    </Box>
  );
}

export default BandarDetector;
